// @file Surface comment attachments store
import { vSet } from '@@/bits/vue'
import type { Cid } from '@@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export enum CommentAttachmentState {
  /** When the comment is in its normal state before picking attachment. */
  IDLE = 'idle',
  /** When the comment attachment is being loaded. */
  LOADING = 'loading',
  /** When the comment attachment has finished loading and is showing as a preview for the user to decide before submitting.  */
  PREVIEW = 'preview',
  /** When the user is dragging something to the comment. */
  DRAGGING = 'dragging',
}

export const useSurfaceCommentAttachmentsStore = defineStore('surfaceCommentAttachments', () => {
  /* ------------------------ */
  /* COMMENT ATTACHMENT STATE */
  /* ------------------------ */

  // This map is used for unsubmitted comments only (that's why the key is post CID -- each post may only have one unsubmitted comment).
  // We store the link object of the comment attachments here.
  const commentAttachmentStateByPostCid = ref<Record<Cid, CommentAttachmentState>>({})

  const updateCommentAttachmentState = ({ postCid, state }: { postCid: Cid; state: CommentAttachmentState }): void => {
    vSet(commentAttachmentStateByPostCid.value, postCid, state)
  }

  const commentAttachmentStateForPostCid = (postCid: Cid): CommentAttachmentState => {
    return commentAttachmentStateByPostCid.value[postCid] ?? CommentAttachmentState.IDLE
  }

  return {
    // Comment attachment state
    commentAttachmentStateByPostCid,
    updateCommentAttachmentState,
    commentAttachmentStateForPostCid,
  }
})
